import {Decoder, equal, oneOf} from 'json-bouncer'

export type M = 'Pending' | 'Declined' | 'Closed' | 'Expired'

export function decoder(): Decoder<M> {
    return oneOf([
        equal<M>('Pending'),
        equal<M>('Declined'),
        equal<M>('Closed'),
        equal<M>('Expired'),
    ])
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestOfferStatus.ts